var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494b74",
    opacity: 0.3,
    d: "M3.25,3h5A1.25,1.25,0,0,1,9.5,4.25V15.917a1.25,1.25,0,0,1-1.25,1.25h-5A1.25,1.25,0,0,1,2,15.917V4.25A1.25,1.25,0,0,1,3.25,3ZM7.833,8A.833.833,0,0,0,7,8.833V10.5a.833.833,0,1,0,1.667,0V8.833A.833.833,0,0,0,7.833,8Z",
    transform: "translate(-0.333 -0.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#494b74",
    d: "M1.25,14.167h5a1.25,1.25,0,0,0,1.25-1.25V1.25A1.25,1.25,0,0,0,6.25,0h-5A1.25,1.25,0,0,0,0,1.25V12.917A1.25,1.25,0,0,0,1.25,14.167Zm4.583-5A.833.833,0,0,1,5,8.333V6.667a.833.833,0,0,1,1.667,0V8.333A.833.833,0,0,1,5.833,9.167Z",
    transform: "translate(18.333 16.667) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.228418c9f2427cf3c68762f33e240549.svg";
export { ForwardRef as ReactComponent };